import { EDIT_ACTION } from "constants/actions";
import {
  ACCOUNT_AGENCY_ID,
  ACCOUNT_DIRECTOR_ID,
  ALL_OPTION,
} from "utility/constants";

export const ALL_AGENCY_OPTION = {
  label: "All Agencies",
  value: ALL_OPTION,
  acronym: "All Agencies",
};

export const ALL_PROGRAM_OPTION = {
  label: "All Programs",
  value: ALL_OPTION,
};

export const validateAccountForm = (action, formFields) => {
  if (
    action === EDIT_ACTION &&
    formFields?.changeEmail?.length !== 0 &&
    formFields.password === ""
  ) {
    return "Password is required when changing email.";
  }

  if (
    action === EDIT_ACTION &&
    formFields?.changeEmail?.length !== 0 &&
    formFields.password !== formFields.passwordConfirmation
  ) {
    return "Passwords must match";
  }

  return true;
};

export const getSelectedAgencies = (formFields, agencyOptions) => {
  let agency = null;

  if (
    formFields?.accountType?.value !== ACCOUNT_DIRECTOR_ID &&
    formFields?.accountType?.value !== ACCOUNT_AGENCY_ID
  ) {
    if (formFields.agencies.some((_agency) => _agency.value === ALL_OPTION)) {
      agency = agencyOptions.map((_agency) => _agency.value);
    } else {
      agency = formFields.agencies.map((_agency) => _agency.value);
    }
  }

  return agency;
};

export const getSelectedPrograms = (formFields, programOptions) => {
  let program = null;

  if (formFields?.accountType?.value === ACCOUNT_AGENCY_ID) {
    if (formFields.programs.some((_program) => _program.value === ALL_OPTION)) {
      program = programOptions
        .filter((_program) => _program.value !== ALL_OPTION)
        .map((_program) => _program.value);
    } else {
      program = formFields.programs.map((_program) => _program.value);
    }
  }

  return program;
};
